<template>
  <form-builder-editor-field
    :item="item"
    :description-rich-edit="true"
    :show-hide-in-form="true"
    v-on="$listeners"
  />
</template>

<script>
import FormBuilderEditorField from "./FormBuilderEditorField";

export default {
  components: {FormBuilderEditorField},

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  setup() {
    return {}
  }
}
</script>




// WEBPACK FOOTER //
// FormBuilderEditorSubheader.vue?715696a4